import { makeTagCache } from 'apprise-core/tag.cache'
import { useL } from 'apprise-frontend-core/intl/multilang'
import { useCategoryStore } from './category/store'
import { useTagStore } from './tag/store'


export type { TagCategoryCache } from 'apprise-core/tag.cache'


export const useTagCache = () => {

    const l = useL()

    const tags = useTagStore()
    const cats = useCategoryStore()

    return makeTagCache(l)
        .withCategories(cats.allCategories())
        .withTags(tags.allTags())

}
